module.exports = __webpack_public_path__ + "img/bag.ead0a352.svg";